module.exports = __webpack_public_path__ + "img/bid_img4.fcd7177b.jpg";